/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppointmentTranscriptionMessage
 */
export interface AppointmentTranscriptionMessage {
    /**
     * 
     * @type {string}
     * @memberof AppointmentTranscriptionMessage
     */
    from: AppointmentTranscriptionMessageFromEnum;
    /**
     * 
     * @type {number}
     * @memberof AppointmentTranscriptionMessage
     */
    date?: number;
    /**
     * 
     * @type {string}
     * @memberof AppointmentTranscriptionMessage
     */
    text: string;
}


/**
 * @export
 */
export const AppointmentTranscriptionMessageFromEnum = {
    Staff: 'Staff',
    Patient: 'Patient'
} as const;
export type AppointmentTranscriptionMessageFromEnum = typeof AppointmentTranscriptionMessageFromEnum[keyof typeof AppointmentTranscriptionMessageFromEnum];


/**
 * Check if a given object implements the AppointmentTranscriptionMessage interface.
 */
export function instanceOfAppointmentTranscriptionMessage(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "from" in value;
    isInstance = isInstance && "text" in value;

    return isInstance;
}

export function AppointmentTranscriptionMessageFromJSON(json: any): AppointmentTranscriptionMessage {
    return AppointmentTranscriptionMessageFromJSONTyped(json, false);
}

export function AppointmentTranscriptionMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentTranscriptionMessage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'from': json['from'],
        'date': !exists(json, 'date') ? undefined : json['date'],
        'text': json['text'],
    };
}

export function AppointmentTranscriptionMessageToJSON(value?: AppointmentTranscriptionMessage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'from': value.from,
        'date': value.date,
        'text': value.text,
    };
}

